import React from 'react';
import { KAKAO_REDIRECT_URI, KAKAO_REST_API_KEY } from '../../../../constants/url';
import MessageTypes from '../../../../bridge/messageTypes';

import kakaoImg from '../../../../images/common/i_kakao.svg';

const KaKaoLogin = () => {

  const handleKakaoLogin = () => {
    // 앱에서는 네이티브 SDK 로 위임한다. 결과는 Landing 이 KAKAO_LOGIN_SUCCESS 로 받는다.
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: MessageTypes.REQUEST_KAKAO_LOGIN }),
      );
      return;
    }

    // scope 를 비우면 카카오 콘솔의 동의항목 설정을 그대로 따른다.
    const redirectUri = encodeURIComponent(KAKAO_REDIRECT_URI);
    window.location.href =
      `https://kauth.kakao.com/oauth/authorize?client_id=${KAKAO_REST_API_KEY}` +
      `&redirect_uri=${redirectUri}&response_type=code&scope=`;
  };

  return (
    <button data-login-btn="kao" onClick={handleKakaoLogin}>
      <img src={kakaoImg} alt="카카오 로그인" />
      <span>카카오로 시작하기</span>
    </button>
  );
};

export default KaKaoLogin;
